import {shuffle} from "../modules/helpers.js"

// Initialize sounds
let audioErrorElement = document.createElement('audio');
audioErrorElement.setAttribute('src', 'static/www/static/music/error.mp3');
let audioSuccessElement = document.createElement('audio');
audioSuccessElement.setAttribute('src', 'static/www/static/music/success.mp3');
let audioSelectElement = document.createElement('audio');
audioSelectElement.setAttribute('src', 'static/www/static/music/select.mp3');
let soundEffects = [audioErrorElement, audioSuccessElement, audioSelectElement];

// Initialize music
let musicFileNames = [
    'Hole.mp3', 'Bash and Trash.mp3', 'Down Hill.mp3', 'Get Serious.mp3', 'Leading Together.mp3',
    'Rocking Adrenaline.mp3', 'Scream Now.mp3', 'Split Between.mp3', 'Sports Junkie.mp3', 'Spring Cleaning.mp3',
    'Thirsty.mp3', 'Too Crazy.mp3', 'Unrelenting.mp3'
];
musicFileNames = shuffle(musicFileNames);
let i = 0;
let audioMusicElement = document.createElement('audio');

// Mute sounds and music
soundEffects.forEach(function (audio) {
    audio.muted = true;
    audio.volume = 0.3;
});
audioMusicElement.autoplay = false;
audioMusicElement.volume = 0.3;

// Go to next song upon song ending
audioMusicElement.addEventListener('ended', function () {
    i++;
    if (i === musicFileNames.length) {
        i = 0;
    }
    this.setAttribute('src', 'static/www/static/music/' + musicFileNames[i]);
    this.play();
}, false);

$(document).ready(function () {

    // Enable / disable music
    $('#music-range').on('input', function () {
        const volume = parseInt($(this).val());

        // Play music
        if (volume > 0) {
            if (!audioMusicElement.getAttribute('src')) {
                audioMusicElement.setAttribute('src', 'static/www/static/music/' + musicFileNames[i]);
            }
            audioMusicElement.play();
            audioMusicElement.volume = volume / 100;
        }
        // Pause music
        else {
            audioMusicElement.pause();
        }
    });

    // Enable / disable sounds
    $('#sound-effects-range').on('input', function () {
        const volume = parseInt($(this).val());

        // Unmute sounds
        if (volume > 0) {
            soundEffects.forEach(function (audio) {
                audio.muted = false;
                audio.volume = volume / 100;
            });
        }
        // Mute sounds
        else {
            soundEffects.forEach(function (audio) {
                audio.muted = true;
            });
        }
    });
    $('#sound-effects-range').on('change', function () {
        playSoundEffect('success');
    });
});

// Function to play sounds
export function playSoundEffect(soundEffectType) {
    if (soundEffectType === 'success') {
        audioSuccessElement.play()
    }
    else if (soundEffectType === 'error') {
        audioErrorElement.play()
    }
}